import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { AuthGuard, LocalAwareMsalGuard } from '~/core/classes/auth/auth.guard';

//******************************************************************************
//  Core Pages
//******************************************************************************
import { AuthComponent } from '~/core/pages/auth/auth.component';
import { NotFoundComponent } from '~/core/pages/notfound/notfound.component';

//******************************************************************************
//  Core Components
//******************************************************************************
import { ErrorComponent } from '~/core/components/error/error.component';
import { AccessComponent } from '~/core/components/access/access.component';

export const routes: any[] = [
    {
        path: 'auth',
        component: AuthComponent,
        canActivate: [LocalAwareMsalGuard]
    },
    {
        path: 'notfound',
        component: NotFoundComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'access',
        component: AccessComponent,
        canActivate: [AuthGuard]
    },
    {
        path: 'error',
        component: ErrorComponent,
        canActivate: [AuthGuard]
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes)
    ],
    exports: [
        RouterModule
    ]
})

export class CoreRouting { }
